/**
 * Type of the callback function executed when an event is dispatched
 */
export type NotificationCallback = (_data: unknown) => void

/**
 * Notifications client to dispatch and listen for events
 */
export const notifications = {
  /**
   * Listen for an event
   * @param event - event name
   * @param callback - callback to execute when the event is dispatched
   */
  on(event: string, callback: NotificationCallback) {
    if (typeof document !== 'undefined') {
      document.removeEventListener(event, callback) // remove existing listeners if any
      document.addEventListener(event, callback)
    }
  },
  /**
   * Dispatch an event
   * @param event - event name
   * @param data - data to pass to the event
   */
  dispatch(event: string, data?: unknown) {
    if (typeof document !== 'undefined') {
      document.dispatchEvent(new CustomEvent(event, { detail: data }))
    }
  },
  /**
   * Remove an event listener
   * @param event - event name
   * @param callback - callback to remove
   */
  remove(event: string, callback: NotificationCallback) {
    if (typeof document !== 'undefined') {
      document.removeEventListener(event, callback)
    }
  },
}
